import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const AtlassianCompactIcon = () => {
  return /*#__PURE__*/_jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    children: /*#__PURE__*/_jsx("path", {
      fill: "currentColor",
      d: "M8.703 11.475c-.237-.253-.61-.239-.767.087L4.05 19.33a.464.464 0 0 0 .415.672h5.412a.448.448 0 0 0 .415-.26c1.167-2.408.46-6.077-1.59-8.267h.001Zm2.851-7.065c-2.174 3.443-2.03 7.257-.598 10.12l2.608 5.217c.078.16.24.26.416.26h5.411a.464.464 0 0 0 .416-.67l-7.46-14.93c-.167-.326-.583-.333-.793.002v.001Z"
    })
  });
};